module.exports = __webpack_public_path__ + "img/niue.74efe863.svg";